"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Phone, MessageCircle, Send } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
export default function Consultation() {
  const shouldReduceMotion = useReducedMotion();
  const channels = [{
    name: "Zalo",
    status: "Sắp cập nhật",
    icon: MessageCircle,
    disabled: true
  }, {
    name: "Messenger",
    status: "Sắp cập nhật",
    icon: Send,
    disabled: true
  }];
  return <section id="curriculumconsultationcta" data-nav="light" className="w-full bg-background border-y border-border relative overflow-hidden">
      <div className="bg-muted/40 w-full py-8 md:py-10">
        <div className="max-w-7xl mx-auto px-6 relative">
          {/* Floating Decorative Mascot */}
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/91d9f023-f981-424e-99f8-0a55492bd5a5.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/91d9f023-f981-424e-99f8-0a55492bd5a5.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/91d9f023-f981-424e-99f8-0a55492bd5a5.png-wvc-sizes" alt="Mascot ROBOTO - Cùng nhau học giỏi" loading="lazy" className="hidden md:block absolute bottom-0 left-0 lg:left-2 w-20 md:w-24 lg:w-28 xl:w-32 h-auto object-contain pointer-events-none select-none z-10" />

          <motion.div initial={shouldReduceMotion ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.35,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col lg:flex-row items-center justify-between gap-6">
            {/* Left side: Heading */}
            <div className="text-center lg:text-left lg:pl-28 xl:pl-32">
              <h2 className="font-serif text-xl sm:text-2xl font-semibold text-foreground tracking-normal">
                Bạn chưa biết lộ trình nào phù hợp với con?
              </h2>
            </div>

            {/* Right side: Action & Quick Contact Cluster */}
            <div className="flex flex-wrap items-center justify-center lg:justify-end gap-3 sm:gap-4">
              {/* Primary Consultation Trigger */}
              <motion.div whileHover={shouldReduceMotion ? {} : {
              scale: 1.02
            }} whileTap={shouldReduceMotion ? {} : {
              scale: 0.98
            }} className="shrink-0">
                <Button asChild className="bg-accent text-accent-foreground font-semibold px-6 py-3 rounded-lg shadow-sm hover:brightness-95 transition-[color,box-shadow,filter]">
                  <Link to="/FreeTrialContactPage">
                    ĐĂNG KÝ TƯ VẤN
                  </Link>
                </Button>
              </motion.div>

              {/* Vertical separator on larger screens */}
              <div className="hidden sm:block h-6">
                <Separator orientation="vertical" className="bg-border h-full" />
              </div>

              {/* Quick Contact Options */}
              <div className="flex items-center gap-2 sm:gap-3">
                <TooltipProvider delayDuration={150}>
                  {channels.map((channel, idx) => {
                  const IconComponent = channel.icon;
                  return <div key={channel.name} data-index={idx}>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <span tabIndex={0} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-border bg-background/50 text-xs font-medium text-muted-foreground opacity-60 cursor-not-allowed select-none transition-colors">
                              <IconComponent className="size-3.5" />
                              <span>{channel.name}</span>
                              <Badge variant="outline" className="text-[10px] py-0 px-1.5 h-4 bg-muted text-muted-foreground border-transparent font-normal">
                                {channel.status}
                              </Badge>
                            </span>
                          </TooltipTrigger>
                          <TooltipContent side="top">
                            <span>Kênh {channel.name} sắp được hỗ trợ</span>
                          </TooltipContent>
                        </Tooltip>
                      </div>;
                })}
                </TooltipProvider>

                {/* Direct Hotline link */}
                <Button asChild variant="outline" size="sm" className="rounded-full border-border bg-background text-foreground hover:bg-accent hover:text-accent-foreground shadow-2xs font-medium px-3.5 py-1.5 text-xs h-auto gap-1.5">
                  <a href="tel:0346386986" className="flex items-center gap-1.5" aria-label="Gọi hotline tư vấn 0346 386 986">
                    <Phone className="size-3.5 text-accent" />
                    <span>0346 386 986</span>
                  </a>
                </Button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}